import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const UploadItemWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",

  minHeight: "55px",
  width: "100%",

  "@media screen and (min-width: 768px)": {
    width: "calc(50% - 40px)",
  },
}));

export const UploadItemInfos = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const UploadItemTitle = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",

  "& > span": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    margin: "0",
    letterSpacing: "0.15px",
    padding: "0",
    textAlign: "left",
  },
}));

export const UploadDocumentButton = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  backgroundColor: colors.white,
  border: `1px solid ${colors.brandBlue500}`,
  borderRadius: "8px",
  height: "40px",
  padding: "8px",
  width: "40px",

  cursor: "pointer",

  "&:hover": {
    background: "#0055A414",
  },
}));
